export default __webpack_public_path__ + "static/media/mini-planets.bd14c578.jpg";